export default "__VITE_ASSET__9f78f55b__"